(function () {
  function bindFaq(section) {
    if (!section || section.dataset.faqBound === "true") {
      return;
    }

    section.dataset.faqBound = "true";

    function closeItem(entry) {
      entry.classList.remove("is-open");
      const toggle = entry.querySelector(".blj-faq__question");
      const answer = entry.querySelector(".blj-faq__answer");

      if (toggle) {
        toggle.setAttribute("aria-expanded", "false");
      }

      if (answer) {
        answer.style.maxHeight = answer.scrollHeight + "px";
        requestAnimationFrame(function () {
          answer.style.maxHeight = "0px";
          answer.style.opacity = "0";
        });
      }
    }

    function openItem(entry, toggle) {
      const answer = entry.querySelector(".blj-faq__answer");
      entry.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");

      if (answer) {
        answer.style.maxHeight = answer.scrollHeight + "px";
        answer.style.opacity = "1";
      }
    }

    section.querySelectorAll(".blj-faq__item").forEach(function (item) {
      const answer = item.querySelector(".blj-faq__answer");
      if (!answer) return;

      if (item.classList.contains("is-open")) {
        answer.style.maxHeight = answer.scrollHeight + "px";
        answer.style.opacity = "1";
      } else {
        answer.style.maxHeight = "0px";
        answer.style.opacity = "0";
      }
    });

    section.querySelectorAll(".blj-faq__item").forEach(function (item) {
      const button = item.querySelector(".blj-faq__question");

      if (!button) {
        return;
      }

      button.addEventListener("click", function () {
        const isOpen = item.classList.contains("is-open");

        section.querySelectorAll(".blj-faq__item").forEach(function (entry) {
          if (entry === item) return;
          closeItem(entry);
        });

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item, button);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll("[data-faq-section]").forEach(bindFaq);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function (event) {
    bindFaq(event.target);
  });
})();
